import BaseItemCollectionView from "./BaseItemCollectionView";

export default class ItemPoolView extends BaseItemCollectionView {

    /**
     * @param {createjs.DisplayObject} target 
     * @param {GameElementSkinFactory} elementFactory 
     * @param {boolean} wrap 
     */
    constructor(target, elementFactory, wrap = false) {
        super(target, elementFactory);
        this._wrap = wrap;

        this._buttonPrev = this.createButton(target.prevButton, this._handlePrev.bind(this));
        this._buttonNext = this.createButton(target.nextButton, this._handleNext.bind(this));

        this._selectedSlot = null;
    }

    set enabled(bool) {
        super.enabled = bool;
        this.update();
    }

    /**
     * 
     * @param {Array<string>} pool Array of item ids
     */
    setPool(pool) {
        this._pool = pool;
        this._index = 0;
        this.update();
    }

    update() {
        this.selectSlot(null);
        //fill slots starting at current index
        const itemIds = [];
        const np = this._pool.length;
        for (let i = 0; i < this._slots.length; i++) {
            itemIds.push(this._pool[(this._index + i + np) % np]);
        }
        this.fill(itemIds);

        if (!this._wrap) {
            this._buttonPrev.setEnabled(this._enabled && this._index > 0);
            this._buttonNext.setEnabled(this._enabled && this._index < np - 1);
        }
    }

    _handlePrev() {
        if (this._wrap) {
            this._index = (this._index - 1 + this._pool.length) % this._pool.length;
        } else {
            this._index = Math.max(0, this._index -1 );
        }
        this.update();
    }

    _handleNext() {
        if (this._wrap) {
            this._index = (this._index + 1) % this._pool.length;
        } else {
            this._index = Math.min(this._index + 1, this._pool.length - this._slots.length)
        }
        
        this.update();
    }
}